"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProviderSchema = exports.createProviderSchema = exports.providerSchema = exports.providerAvailabilitySchema = void 0;
// Legacy provider-shaped schema kept as an alias view over the unified
// Resource model. The /providers API returns Resource rows where
// type IN (PROVIDER, COMMUNITY_PROVIDER), mapped to this shape for the
// existing frontend.
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.providerAvailabilitySchema = zod_1.z
    .object({
    day: zod_1.z.enum(enums_js_1.DayOfWeeks),
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
})
    .refine((v) => v.startMin < v.endMin, { message: 'startMin must be less than endMin' });
exports.providerSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    externalRef: zod_1.z.string().nullable().optional(),
    email: zod_1.z.string().email().nullable().optional(),
    cellPhone: zod_1.z.string().nullable().optional(),
    role: zod_1.z.enum(enums_js_1.ProviderRoles),
    serviceTypes: zod_1.z.array(zod_1.z.enum(enums_js_1.ServiceTypes)),
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    telehealthCapable: zod_1.z.boolean().optional(),
    maxDirectHoursPerWeek: zod_1.z.number().int(),
    active: zod_1.z.boolean(),
    notes: zod_1.z.string().nullable().optional(),
    availability: zod_1.z.array(exports.providerAvailabilitySchema),
});
exports.createProviderSchema = zod_1.z.object({
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    externalRef: zod_1.z.string().optional(),
    email: zod_1.z.string().email().optional(),
    cellPhone: zod_1.z.string().optional(),
    role: zod_1.z.enum(enums_js_1.ProviderRoles),
    serviceTypes: zod_1.z.array(zod_1.z.enum(enums_js_1.ServiceTypes)).default([]),
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService).default('OFFICE'),
    telehealthCapable: zod_1.z.boolean().optional(),
    maxDirectHoursPerWeek: zod_1.z.number().int().min(0).max(168).default(28),
    notes: zod_1.z.string().optional(),
    availability: zod_1.z.array(exports.providerAvailabilitySchema).default([]),
});
exports.updateProviderSchema = exports.createProviderSchema.partial().extend({
    active: zod_1.z.boolean().optional(),
    locationId: zod_1.z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=provider.js.map